import type { ModalActionHandler } from './modalActionTypes';
import { assignJob, getFreePopulation, MAX_SMELTERS } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const hireSmelterAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_SMELTERS * settlement.buildings.smelter.qty;
    if (settlement.jobs.smelters >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'smelters')) return false;
    return true;
};
